import { logEvent } from "firebase/analytics"
import { get, isEmpty } from "lodash-es"
import { getRecoil } from "recoil-nexus"

import { userStateForAnalytics } from "@fuse/recoil/signup"

import { analytics } from "@firebaseConfig/clientApp"

import { isDev } from "@fuse/utils/common"

type AnalyticsEventParams = {
  [key: string]: any
}

export enum ELogAnalyticEvent {
  LANDING_WEB = "landing_web",
  EVENT_DETAILS_WEB = "event_details_web",
  CHOOSE_TICKET_WEB = "chooseTicket_web",
  FILL_QUESTIONNAIRE_WEB = "fillQuestionnaire_web",
  STRIPE_CHECKOUT_WEB = "stripeCheckout_web",
  OPEN_EXTERNAL_EVENT_WEB = "openExternalEvent_web",
  CURATED_FRIENDS = "CuratedFriends_web",
  QUICK_SIGN_UP_WEB = "quickSignUp_web",
  SIGN_UP_WEB = "signUp_web",
}

export enum ELogGTMEvent {
  BUTTON_CLICK = "button_click",
  PAGE_VIEW = "page_view",
}

export const logAnalyticEvent = (
  eventName: string,
  eventParams: AnalyticsEventParams,
): void => {
  if (isDev()) {
    console.warn(
      "You're in dev mode, analytics logEvent is restricted for dev user!",
    )
    return
  }

  const userStateForAnalyticsValue = getRecoil(userStateForAnalytics)
  const userId = get(userStateForAnalyticsValue, "userId", "")
  if (!isEmpty(userId)) {
    const updatedEventParams = { ...eventParams, ...userStateForAnalyticsValue }
    logEvent(analytics, eventName, updatedEventParams)
  }
}
